export class VentasComercio {
  id: number;
  fechaHora: string;
  cliente: string;
  nombre: string;
  apellido: string;
  nroSolicitud: number;
  estadoSolicitud: string;
  importe: number;
  carrito: [];
  datosCompra: [];
  comercio: string;


  constructor(id?: number, fechaHora?: string, cliente?: string, nombre?: string, apellido?: string, nroSolicitud?: number, estadoSolicitud?: string, importe?: number, carrito?: [], datosCompra?: [], comercio?: string) {
    this.id = id ?? null;
    this.fechaHora = fechaHora ?? '';
    this.cliente = cliente ?? '';
    this.nombre = nombre ?? '';
    this.apellido = apellido ?? '';
    this.nroSolicitud = nroSolicitud ?? 0;
    this.estadoSolicitud = estadoSolicitud ?? '';
    this.importe = importe ?? 0;
    this.carrito = carrito ?? [];
    this.datosCompra = datosCompra ?? [];
    this.comercio = comercio ?? '';
  }
}
